import Vue from 'vue';

const eventBus = new Vue();
window._move_bus = eventBus;

const installer = {
  install(Vue) {
    Vue.prototype.$bus = eventBus;
  },
};

export default installer;
